//import { rejects } from "assert";


class ExamService {
    url: string = "../Ashx/Examination.ashx";
    TestUID: string = ""
    constructor() {
        if (process.env.NODE_ENV == "development") {
            this.url = "http://localhost:56400/Ashx/Examination.ashx";
        }
        //console.log("init webservice ", this.url)           

        //this.TestUID='E222600814'
        this.TestUID = 'F125960334'
    }

    sayHello = async (): Promise<object> => {
        return await this.asyncSayHello();
    }

    tempDataAction = async (tdo:TempDataObject): Promise<object> => {
        return await this.asyncTempDataAction(tdo);
    }

    saveExamResult = async (ActID: string, ExamID: string, Score: string): Promise<object> => {
        return await this.asyncSaveExamResult(ActID, ExamID, Score);
    }

    getExamComplete = async (ActID: string, ExamID: string): Promise<object> => {
        return await this.asyncGetExamComplete(ActID, ExamID);
    }

    resetExamComplete = async (): Promise<object> => {
        return await this.asyncResetExamComplete();
    }

    getExamList = async (eid: string, option: string = "0", recNum: string = "10"): Promise<object> => {
        return await this.asyncGetExamList(eid, option, recNum);
    }

    getExamInfo = async (eid: string): Promise<object> => {
        return await this.asyncGetExamInfo(eid);
    }

    asyncTempDataAction = async (tdo:TempDataObject): Promise<object> =>{
        let formData = new FormData();
        formData.append("RequestType", "TempDataAction");
        formData.append("Action", tdo.Action);
        formData.append("ActID", tdo.ActID);
        formData.append("ExamID", tdo.ExamID.toString());

        if(tdo.TempData){
            formData.append("TempData", tdo.TempData);
        }

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                console.log(res)
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                //reject()
                reject()
            });
        })
    }

    asyncSayHello = async (): Promise<object> =>{
        let formData = new FormData();
        formData.append("RequestType", "SayHello");

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                console.log(res)
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                //reject()
                reject()
            });
        })
    }

    asyncGetExamInfo = (eid: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetExamInfo");
        formData.append("ExamID", eid);

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                //reject()
                resolve(false)
            });
        })
    }

    asyncGetExamList = (eid: string, option: string, recNum: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetExamList");
        formData.append("ExamID", eid);
        formData.append("Option", option);//自選題1|非自選題0
        formData.append("recNum", recNum);//撈回來的題數，預設10題

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                /* 資料處理：
                * 由於Answers在SQL已先使JSON string處理過，因此前端取回資料的時候先行將string處理回JSON物件以利後續處理。* */
                //console.log(res)
                if (res.Result == "OK") {
                    resolve(res)
                } else {
                    console.error('[HIB168 錯誤] => 連線成功但取得資料失敗。');
                    reject()
                }
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }

    asyncSaveExamResult = (ActID: string, ExamID: string, Score: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "SaveExamResult");
        formData.append("ActID", ActID);
        formData.append("ExamID", ExamID);
        formData.append("Score", Score);
        //formData.append("Score", score.toString());

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                if (res.Result == "OK") {
                    resolve(res)
                } else {
                    console.error('[HIB168 錯誤] => 連線成功但取得資料失敗。');
                    reject()
                }
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }

    asyncGetExamComplete = (ActID: string, ExamID: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetExamComplete");
        formData.append("ActID", ActID);
        formData.append("ExamID", ExamID);

        if (process.env.NODE_ENV == "development") {
            formData.append("TestUID", this.TestUID);
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                if (res.Result == "OK") {
                    resolve(res)
                } else {
                    console.error('[HIB168 錯誤] => 連線成功但取得資料失敗。');
                    reject()
                }
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }

    asyncResetExamComplete = (): object => {
        let formData = new FormData();
        formData.append("RequestType", "ResetExamComplete");
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                if (res.Result == "OK") {
                    resolve(res)
                } else {
                    console.error('[HIB168 錯誤] => 連線成功但取得資料失敗。');
                    reject()
                }
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }

   

}


export default ExamService